import { render, staticRenderFns } from "./manage-customer.vue?vue&type=template&id=3a7cdf62&"
import script from "./manage-customer.vue?vue&type=script&lang=js&"
export * from "./manage-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports